// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc572e5a","667":"ea1fef4f","812":"aab7f0f7","963":"f348b441","977":"54187523"}[chunkId] + ".chunk.js";
};